import { Link, useNavigate } from "react-router-dom";
import { Palette, Link2, BellRing, PiggyBank, Download, Users } from "lucide-react";
import { FundraiserInfo } from "../components/coach/FundraiserInfo";
import { Header } from "../components/Header";
import { Breadcrumbs, PublicFooter } from "../components/PublicChrome";
import { useSeo, breadcrumbs, ORGANIZATION } from "../lib/seo";

const CRUMBS = [["Home", "/"], ["Club sign-up", "/clubs"]];
const DESC = "How club sign-up works: create a free coach account, set your club look once and share one link – parents design and pay for their own shields.";
const STEPS = [
  [Users, "Sign up as a coach", "Create a free coach account and a squad for each team."],
  [Palette, "Set the club look", "Choose the background, colours and crest once – every player matches."],
  [Link2, "Share one parent link", "Parents find their child, upload the photo, enter the stats and pay."],
  [BellRing, "Track progress", "Get an email and dashboard alert as each parent finishes; send one-tap reminders."],
  [Download, "Review & share", "Download every shield, fix anything yourself, and share a squad poster."],
  [PiggyBank, "Raise funds", "Your club raises €5–€15 on every shield ordered through its squads."],
];

export default function Clubs() {
  const nav = useNavigate();
  useSeo({ title: "Club Sign-Up – How Squad Orders Work | sportsshields.ie", description: DESC, path: "/clubs",
    jsonLd: { "@context": "https://schema.org", "@graph": [ORGANIZATION, breadcrumbs(CRUMBS)] } });
  return (
    <div className="min-h-screen">
      <Header onNew={() => nav("/design")} />
      <main className="mx-auto max-w-6xl px-4 py-8 sm:px-6 lg:py-12">
        <Breadcrumbs items={CRUMBS} />
        <h1 className="font-display mt-4 text-4xl font-black uppercase leading-none tracking-tight sm:text-5xl" data-testid="clubs-title">How club sign-up works</h1>
        <p className="mt-4 max-w-2xl text-slate-600">{DESC}</p>
        <section className="mt-10" aria-labelledby="how-h">
          <h2 id="how-h" className="font-display text-3xl font-black uppercase">Sign up in 6 steps</h2>
          <ol className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {STEPS.map(([Icon, t, d], i) => (
              <li key={t} className="border-2 border-slate-200 bg-white p-5">
                <div className="flex items-center gap-2"><span className="font-cond flex h-8 w-8 items-center justify-center bg-slate-900 font-bold text-lime-300">{i + 1}</span><Icon className="h-5 w-5" /></div>
                <h3 className="font-display mt-3 text-lg font-extrabold uppercase">{t}</h3><p className="mt-1 text-sm text-slate-600">{d}</p>
              </li>
            ))}
          </ol>
        </section>
        <div className="mt-14"><FundraiserInfo /></div>
        <div className="mt-10 flex flex-wrap gap-3">
          <Link to="/coach?mode=register" className="btn-blaze px-6 py-3 text-sm" data-testid="clubs-signup-button">Sign up your club</Link>
          <Link to="/help#coach" className="border-2 border-slate-900 px-6 py-3 text-sm font-bold hover:bg-slate-100" data-testid="clubs-video-link">Watch the coach video</Link>
          <Link to="/shields" className="px-6 py-3 text-sm font-bold underline" data-testid="clubs-prices-link">See sizes & prices</Link>
          <Link to="/club-fundraising-ideas" className="px-6 py-3 text-sm font-bold underline" data-testid="clubs-ideas-link">Club fundraising ideas</Link>
        </div>
      </main>
      <PublicFooter />
    </div>
  );
}
